import { render } from "./HistoryGetFriend.vue?vue&type=template&id=0865985e"
import script from "./HistoryGetFriend.vue?vue&type=script&lang=js"
export * from "./HistoryGetFriend.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__